export const environment = {
  production: false,
  servicePaused: true,
  baseUrl: 'https://cfprobeta.foreverbambu.me',
  imagesBaseUrl: 'https://cfprobeta.foreverbambu.me/images',
  lambdaUrls: {
    email:
      'https://tri6ajayhjsxmyv4pyol2cxqpq0vmpez.lambda-url.us-east-1.on.aws/',
    stripe:
      'https://wmp5hawdbwk3znvge2vrqox4xe0zfufv.lambda-url.us-east-1.on.aws/',
    pdfGenerator:
      'https://yxqkqvswpf7tchyjflkws7oy4i0tngmk.lambda-url.us-east-1.on.aws/',
    climatiq: 'https://dhaz6mrfdqjdhhqv2wuw4dnbqa0cscui.lambda-url.us-east-1.on.aws/',
  },
  s3: {
    bucket: 'foreverbamboo02d5d96158cd414aab981b8bf13e9f83052ca-dev',
    region: 'us-east-1',
  },
  stripeKey:
    'pk_test_51KyyBBAraWPMLHWjl79QcEoNliyxQc1G2Sdv268InpwggolrCgHp0IlmLSV6xpTVWgaQNukdlkYIzkTncof1gwk100QosPbYsQ',
  stripePrices: {
    consultantBasic: 'price_1THQDyAraWPMLHWjcEA0WEba',
    consultantPro: 'price_1THQEAAraWPMLHWjSHr9yRKr',
    consultantMaster: 'price_1THQEBAraWPMLHWjp0Mzzedy',
    corporate1LicenseMonthly: 'price_1THQECAraWPMLHWjiKaHCUGx',
    corporate1LicenseYearly: 'price_1THQEDAraWPMLHWjbMblAlRT',
    corporate2LicensesMonthly: 'price_1THQEEAraWPMLHWjGmBjiycJ',
    corporate2LicensesYearly: 'price_1THQEFAraWPMLHWjbu53eYTs',
    report: 'price_1THQEHAraWPMLHWjIaeHTOAQ',
    logo: 'price_1THQEIAraWPMLHWjjd6IT6aR',
  },
  courseDirectorEmail: 's.jimenez@digitaloriented.it',
  enrollmentEmail: 's.jimenez@digitaloriented.it',
};
